/**
 * Le nom du jeu, en haut du rail des scores, pendant une partie.
 *
 * Il fait ce qu'un logo fait partout ailleurs sur le web : il ramene a
 * l'accueil. Mais ici ce geste COUTE une place a une table qui joue, donc il
 * demande confirmation. Un logo qui ejecte d'une partie au premier clic serait
 * un piege, d'autant qu'on le clique souvent par reflexe.
 *
 * La confirmation ne BLOQUE rien (cf. CLAUDE.md, aucune modale bloquante
 * pendant le jeu) : les chronos continuent derriere, le dessin reste ou il en
 * etait, et la feuille se ferme a Echap, au RETOUR du navigateur ou en cliquant
 * a cote. Elle ne s'ouvre d'ailleurs que sur un geste deliberé du joueur.
 */
import { useState, type ReactElement } from 'react';
import { useT } from '../locales/useT.js';
import { leaveRoom } from '../net/leaveRoom.js';
import { navigate } from '../router.js';
import { useDismissOnBack } from './useDismissOnBack.js';

export function GameBrand(): ReactElement {
  const t = useT();
  const [asking, setAsking] = useState(false);
  useDismissOnBack(asking, () => setAsking(false));

  const quit = (): void => {
    leaveRoom();
    navigate('/');
  };

  return (
    <>
      <button type="button" className="game-brand" onClick={() => setAsking(true)}>
        {t('app.title')}
      </button>

      {asking && (
        /* AU CENTRE et AU-DESSUS de tout. Pose en feuille du bas, la question
           passait derriere la barre d'outils du dessin, qui occupe justement ce
           bord : on lisait « Voulez-vous vr… » et les deux boutons etaient hors
           d'atteinte. Une question qui reclame une reponse ne peut pas se cacher
           derriere autre chose. */
        <div className="confirm-layer">
          <button
            type="button"
            className="confirm-layer__scrim"
            aria-label={t('common.close')}
            onClick={() => setAsking(false)}
          />
          {/* Pas de croix ici, contrairement aux feuilles de l'accueil : « Non »
              EST la sortie, visible et nommee. Deux sorties qui font la meme
              chose sur un si petit ecran, c'en est une de trop, et la croix
              venait mordre le titre. Echap, le RETOUR et le clic a cote
              ferment aussi. */}
          <section className="confirm" role="dialog" aria-label={t('game.leaveConfirm')}>
            <h2 className="confirm__title">{t('game.leaveConfirm')}</h2>
            {/* Rester est le choix par defaut : c'est celui qui ne detruit
                rien. Le bouton primaire, l'or, va donc a « Non ». */}
            <div className="confirm__actions">
              <button type="button" className="button-ghost" onClick={quit}>
                {t('common.yes')}
              </button>
              <button
                type="button"
                className="button-primary"
                onClick={() => setAsking(false)}
              >
                {t('common.no')}
              </button>
            </div>
          </section>
        </div>
      )}
    </>
  );
}
